<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      img: 'success.svg',
      bgColor: 'extra-green',
      textColor: 'white',
    }"
    :body="{ class: 'text-center' }"
    :footer="{ class: 'text-center' }"
    size="sm"
    :quasar-props="{ maximized: false }"
    @hide="$emit('onClose')"
  >
    <template #body>
      {{ $t("ETAB.PAGES.SUBSCRIPTION.@SUCCESS_SUBSCRIPTION_DESCRIPTION") }}
    </template>
    <template #footer>
      <QBtn no-caps color="extra-green" :label="btnLabel" class="btn-navigation btn-large" @click="$emit('createDemandOrSuccess')" />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      btnLabel: {
        type: String,
        default: "",
      },
    },
    emits: ["update:open", "createDemandOrSuccess", "onClose"],
    computed: {
      internalOpen: {
        get() {
          return this.open;
        },
        set() {
          this.$emit("update:open", false);
        },
      },
    },
  };
</script>
